import DefaultItem from './DefaultItem';

export default DefaultItem;
